export default function itemZoom(key:any) {
    //console.log(key);
    return { type: "ITEMZOOM", payload: key };
  }